import React, { useState } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import Config from "../Config";
import { useNavigate } from "react-router-dom";
import { useAuthHandling } from "../useAuthhandling";
import Toastmodal from "../Toastmodal";
import Cookies from "js-cookie";

function Propertytypeadd() {
  const { isAuthorized, handleUnauthorized } = useAuthHandling();
  let navigate = useNavigate();

  const [banner , setBanner] = useState({
     title :"" ,
      file:"",
      status:'',
      fileType:''
 });

 const [toastmodal, setToastmodal] = useState(false);
 const [toastmessage, setToastmessage] = useState("");
 const [toasttype, setToasttype] = useState("");
 const [toastlarge, setToastlarge] = useState(false);

 const [formerror, setError] = useState({});

let name , value;

const  handleInputs = (e) =>{
     name = e.target.name;
     value = e.target.value;
     setBanner({...banner,[name]:value});
 } 
 
 const onFileChange = (e)=>{
   let name = e.target.name;
   setBanner({ ...banner,[name]: e.target.files[0] });
 };


const PostData = async (e) => {
  e.preventDefault();
  let formvalid=true;
  const errors = {};
 if (!banner.propertyType) {
   errors.propertyType = "Property type is required!";
   formvalid=false;
 }

 if (!banner.propertyTypeCategory) {
   errors.propertyTypeCategory = "Property type category is required!";
   formvalid=false;
 }
 if (!banner.status) {
   errors.status = "status is required!";
   formvalid=false;
 } 
 
 if (!banner.canonicalURL) {
   errors.canonicalURL = "Canonical URL is required!";
   formvalid=false;
 } 
 if (!banner.metaDescription) {
   errors.metaDescription = "Meta description is required!";
   formvalid=false;
 } 
 if (!banner.metaTitle) {
   errors.metaTitle = "Meta title is required!";
   formvalid=false;
 } 
//  if (!banner.file) {
//    if(!banner.fileUploadPath){
//      errors.file = "File is required!";
//      formvalid=false;
//    }
//  } 
//  else{
   
//      if (
//        banner.file.type === "image/jpeg" ||
//        banner.file.type === "image/jpg" ||
//        banner.file.type === "image/png" ||
//        banner.file.type === "image/webp" 
//      ) {
//        if (banner.file.size > 1024 * 1000) {
//          errors.file =
//            "maximum file size 1 mb...please upload an image less than 1 mb";
//            formvalid=false;
//        }
//      } else {
//        errors.file = "Only support jpg, jpeg, png, webp image!";
//        formvalid=false;
//      }
   
 
//  }

  setError(errors);
 if(formvalid===true){
     const formData = new FormData();
     formData.append("propertyType",banner.propertyType);
     formData.append("propertyTypeCategory",banner.propertyTypeCategory);
     formData.append("status",banner.status);
     formData.append("metaTitle",banner.metaTitle);
     formData.append("metaDescription",banner.metaDescription);
     formData.append("canonicalURL",banner.canonicalURL);
     if(banner.file){
       formData.append("file",banner.file);
     }
     
     axios
     .post(`${Config.apiurl}/api/v1/crm/property-types/create`, formData,{ headers: {
       Authorization: `Bearer ${Cookies.get("a_token")}`,
       "Content-type": "application/json; charset=UTF-8",
     },}).then((res) => {

       if (res.status === 200 ){
         setToastmodal(true);
         setToastmessage("Sucessfully updated Property type");
         setToasttype("success");
         setToastlarge(false);
         setTimeout(() => navigate("/dashboard"), 3000);
       }
       else if(res.status === 401){
         handleUnauthorized();
         PostData();
       }
       else {
         setToastmodal(true);
         setToastmessage("Something went wrong!");
         setToasttype("error");
         setToastlarge(false);
       }
     });
   }
};

     return(
      <div>
        <div className="container-scroller">
          <Navbar />
          <div className="container-fluid page-body-wrapper">
            <Sidebar />
            <div className="main-panel">
              <div className="content-wrapper">
                <div className="row">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body">
                        <h4 className="card-title">Property Type</h4>
                        <p className="card-description">Add New Property Type</p>
                        <form className="forms-sample" onSubmit={PostData}>
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Type</label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Type"
                              name="propertyType"
                              value={banner.propertyType}
                              onChange={handleInputs}
                            />
                               <label style={{ color: "red" }}>{formerror.propertyType}</label>
                          </div>
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Type Category</label>
                            <select className="form-select" name="propertyTypeCategory" value={banner.propertyTypeCategory} onChange={handleInputs}>
                            <option>Select..</option>
                            <option value='Residential'>Residential</option>
                            <option value='Commercial'>Commercial</option>

                           </select>
                           
                           <label style={{ color: "red" }}>{formerror.propertyTypeCategory}</label>
                          </div>
                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Canonical URL</label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Canonical URL"
                              name="canonicalURL"
                              value={banner.canonicalURL}
                              onChange={handleInputs}
                            />
                           <label style={{ color: "red" }}>{formerror.canonicalURL}</label>
                          </div>
                          
                          <div className="form-group">
                            <label htmlFor="exampleInputEmail1">File</label>
                            <br></br>
                            <input type="file" name="file" onChange={onFileChange} />
                            <div className='clearfix'></div>
                            {banner.fileUploadPath?
                        <img src={banner.fileUploadPath} style={{width:"100px",height:"100px",marginTop:"10px"}}/>
                        :
                       ""
                        }
                            <label style={{ color: "red" }}>{formerror.file}</label>
                          </div>

                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Meta Title</label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Meta Title"
                              name="metaTitle"
                              value={banner.metaTitle}
                              onChange={handleInputs}
                            />
                           <label style={{ color: "red" }}>{formerror.metaTitle}</label>
                          </div>

                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Meta Description</label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleInputUsername1"
                              placeholder="Meta Description"
                              name="metaDescription"
                              value={banner.metaDescription}
                              onChange={handleInputs}
                            />
                           <label style={{ color: "red" }}>{formerror.metaDescription}</label>
                          </div>

                          <div className="form-group">
                            <label htmlFor="exampleInputUsername1">Status</label>
                            <select className="form-select" name="status" value={banner.status} onChange={handleInputs}>
                            <option>Select..</option>
                            <option value={true}>Active</option>
                            <option value={false}>Inactive</option>

                           </select>
                           <label style={{ color: "red" }}>{formerror.status}</label>
                          </div>
                          <button
                            type="submit"
                            onClick={PostData}
                            className="btn btn-primary me-2"
                          >
                            Submit
                          </button>

                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {toastmodal ? (
        <Toastmodal
          setToast={setToastmodal}
          message={toastmessage}
          type={toasttype}
          large={toastlarge}
        />
      ) : (
        ""
      )}
      </div>
    );
  }


export default Propertytypeadd;
